export const otherPermission = {
  funelCardAction: false,
};
